import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-5" }
const _hoisted_2 = { class: "dialog-footer" }

import { ref } from "vue";
import PaymentService from "../../services/PaymentService";
import MsgPrompt from "@/core/plugins/MsgPrompt";


export default /*#__PURE__*/_defineComponent({
  __name: 'AutoTransferSetting',
  setup(__props, { expose: __expose }) {

const dialogRef = ref(false);
const isLoading = ref(false);
const formData = ref({
  enabled: false,
  amount: 0,
});

const show = () => {
  dialogRef.value = true;
  fetchData();
};

const fetchData = async () => {
  isLoading.value = true;
  try {
    const response = await PaymentService.transferAutoComplete();
    formData.value.enabled = response.enabled;
    formData.value.amount = response.amount / 100;
  } catch (error) {
    MsgPrompt.error(error);
  }
  isLoading.value = false;
};

const submit = async () => {
  isLoading.value = true;
  try {
    await PaymentService.updateTransferAutoComplete({
      enabled: formData.value.enabled,
      amount: formData.value.amount * 100,
    });
    MsgPrompt.success("Auto Transfer Setting updated successfully").then(() => {
      dialogRef.value = false;
    });
  } catch (error) {
    MsgPrompt.error(error);
  }
  isLoading.value = false;
};

__expose({
  show,
});

return (_ctx: any,_cache: any) => {
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: dialogRef.value,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dialogRef).value = $event)),
    title: "Auto Transfer Setting",
    width: "500",
    "align-center": ""
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_button, {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (dialogRef.value = false)),
          disalbed: isLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode("Cancel")
          ]),
          _: 1
        }, 8, ["disalbed"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: submit,
          loading: isLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Submit ")
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, { label: "Enabled" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_el_switch, {
                  modelValue: formData.value.enabled,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.enabled) = $event)),
                  disalbed: isLoading.value
                }, null, 8, ["modelValue", "disalbed"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "Amount" }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createVNode(_component_el_input_number, {
                  modelValue: formData.value.amount,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.amount) = $event)),
                  disalbed: isLoading.value
                }, null, 8, ["modelValue", "disalbed"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})